import { api } from '../api'
import type { PlayerAction } from '@acepoker/contract'

export const generateSequenceForPredefined = async (
  config: Record<string, string | string[] | { oneOf: string[] }>
): Promise<PlayerAction[]> =>
  await api().url('/api/drill/generate-sequence-for-predefined').post(config).json()
